import {Collapse, Typography, useTheme} from "@mui/material";
import * as React from 'react';
import {InputErrorMessageProps} from "@/types/form";


export default function InputErrorMessage({errorMessage, error}: InputErrorMessageProps) {
    const theme = useTheme()

    return (
        <Collapse in = {error} >
            <Typography
                fontSize = {12}
                py={.5}
                textAlign = 'center'
                color = {theme.palette.error.contrastText}
                bgcolor={theme.palette.error.main}
            >
                {errorMessage}
            </Typography >
        </Collapse >
    )
}
